import { CSS } from '@grupoboticario/flora-react'

export const modalWrapperCss: CSS = {
  width: '100%'
}

export const centeredTextCss: CSS = {
  textAlign: 'center',
  lineHeight: '24px'
}
